export const NO_VALUE_OPERATORS = ['iu', 'hav'];

export const RELATIVE_DAYS_OPERATORS = ['ltd', 'ed', 'mtd'];

export const FILTER_TYPE = {
  STRING: 'string',
  DATE: 'date',
  SELECT: 'select',
  TAG: 'tag',
  FOLDER: 'folder',
};
